/* credit goes to https://css-tricks.com/:
 * https://css-tricks.com/converting-color-spaces-in-javascript/#hex-to-rgb
 * Slight formatting changes for cypress tests, default return value is regular rgb
 */
function hex2rgb(h) {
  var forCypressTest = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var r = 0;
  var g = 0;
  var b = 0; // 3 digits

  if (h.length === 4) {
    r = "0x".concat(h[1]).concat(h[1]);
    g = "0x".concat(h[2]).concat(h[2]);
    b = "0x".concat(h[3]).concat(h[3]); // 6 digits
  } else if (h.length === 7) {
    r = "0x".concat(h[1]).concat(h[2]);
    g = "0x".concat(h[3]).concat(h[4]);
    b = "0x".concat(h[5]).concat(h[6]);
  }

  if (forCypressTest) {
    return "rgb(".concat(+r, ", ").concat(+g, ", ").concat(+b, ")");
  }

  return "rgb(".concat(+r, ",").concat(+g, ",").concat(+b, ")");
}

export default hex2rgb;